export function DeleteIcon({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.75 3.5H12.25"
        stroke="#6B6B6B"
        strokeWidth="0.933333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6665 3.49996V2.33329C4.6665 2.02387 4.78942 1.72713 5.00821 1.50833C5.22701 1.28954 5.52375 1.16663 5.83317 1.16663H8.1665C8.47592 1.16663 8.77267 1.28954 8.99146 1.50833C9.21025 1.72713 9.33317 2.02387 9.33317 2.33329V3.49996"
        stroke="#6B6B6B"
        strokeWidth="0.933333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0832 3.5V11.6667C11.0832 11.9761 10.9603 12.2728 10.7415 12.4916C10.5227 12.7104 10.2259 12.8333 9.9165 12.8333H4.08317C3.77375 12.8333 3.47701 12.7104 3.25821 12.4916C3.03942 12.2728 2.9165 11.9761 2.9165 11.6667V3.5"
        stroke="#6B6B6B"
        strokeWidth="0.933333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.8335 6.41663V9.91663"
        stroke="#6B6B6B"
        strokeWidth="0.933333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.1665 6.41663V9.91663"
        stroke="#6B6B6B"
        strokeWidth="0.933333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
